export const SET_MAP_BOUNDS = 'SET_MAP_BOUNDS';
export const SHOW_MAP_SIDEBAR = 'SHOW_MAP_SIDEBAR';
export const SHOW_MAP_LEGEND = 'SHOW_MAP_LEGEND';
export const SHOW_NAV_DRAWER = 'SHOW_NAV_DRAWER';
export const SET_SIDEBAR_CONTEXT = 'SET_SIDEBAR_CONTEXT';
export const SET_MAP_PROMISE = 'SET_MAP_PROMISE';
export const ADD_ALERT = 'ADD_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const ADD_LOADING = 'ADD_LOADING';
export const REMOVE_LOADING = 'REMOVE_LOADING';
export const SHOW_CHART_MODAL = 'SHOW_CHART_MODAL';
export const SET_CHART_MODAL_TAB = 'SET_CHART_MODAL_TAB';
export const SHOW_TOAST = 'SHOW_TOAST';
export const SET_TOAST_TEXT = 'SET_TOAST_TEXT';
export const TRIGGER_TOAST = 'TRIGGER_TOAST';
export const SELECT_STATION = 'SELECT_STATION';
export const SELECT_WATERSHED = 'SELECT_WATERSHED';
export const SELECT_LICENCE = 'SELECT_LICENCE';
export const SET_MAP_CENTER = 'SET_MAP_CENTER';
export const SET_SELECTED_STATION_DATA = 'SET_SELECTED_STATION_DATA';
export const SET_SELECTED_TABLE_DATA = 'SET_SELECTED_TABLE_DATA';
export const SET_MAP_SOURCE_DATA_LOADED = 'SET_MAP_SOURCE_DATA_LOADED';
export const SET_LOADED_FILTERS = 'SET_LOADED_FILTERS';
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS';
export const SET_FILTER_SETTINGS = 'SET_FILTER_SETTINGS';
export const UNLOAD_FILTERS = 'UNLOAD_FILTERS';
export const RESET_LOADSTATE_ITEMS = 'RESET_LOADSTATE_ITEMS';
export const SET_LOADSTATE_MAP_CENTER = 'SET_LOADSTATE_MAP_CENTER';
export const SET_LOADSTATE_MAP_ZOOM = 'SET_LOADSTATE_MAP_ZOOM';
export const SET_LOADSTATE_MAP_FILTER_SETTINGS = 'SET_LOADSTATE_MAP_FILTER_SETTINGS';
export const SET_LOADSTATE_SELECTED_FEATURE = 'SET_LOADSTATE_SELECTED_FEATURE';



// WEBPACK FOOTER //
// ./src/constants/actions.js